/* eslint-disable import/prefer-default-export */
const ACTION_BTN = 'tw-border-[2px] tw-border-solid tw-border-teal tw-rounded-full tw-p-[8px] tw-px-[20px] tw-text-14d !tw-text-teal';
const ACTION_BTN_LABEL = "tw-mr-[16px] tw-text-gray-50 tw-text-12d tw-font-semibold";

export { 
  ACTION_BTN,
  ACTION_BTN_LABEL
};